import Pagination from './Pagination'
import DetailList from './DetaiList'
import Divider from './Divider'
import Uploader from './Uploader'
import SpecPicker from './SpecPicker'

// export global component here {'name' => Component}

export default {
  'pagination': Pagination,
  'detail-list': DetailList,
  'detail-list-item': DetailList.Item,
  'divider': Divider,
  'uploader': Uploader,
  'spec-picker': SpecPicker,
}
